import { Component, ViewChild, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationUser } from './../../services/ApplicationUser';
import { Http } from '@angular/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {UsersService} from "../../models/users/users.service";
import {UsersModel} from "../../models/users/users.model";
import {ValidationService} from "../../services/validation.service";
import {ToasterService} from 'angular2-toaster/angular2-toaster';
import {SlackApi} from "../../components/slack-api/slack-api.component";

class FormFields {
    private _formFields: any = [
        {name: 'name', label: 'Name', required: ''},
        {name: 'email', label: 'Email', required: ''},
        {name: 'password', label: 'Password', placeholder: 'Enter New Password', required: ''},
        {name: 'smtp_user', label: 'SMTP User', required: ''},
        {name: 'smtp_pass', label: 'SMTP Pass', required: ''},
        {name: 'smtp_server', label: 'SMTP Server', required: ''},
        {name: 'smtp_port', label: 'SMTP Port', maxlength: 11, required: ''},
        {name: 'smtp_method', label: 'SMTP Method', required: ''},
        {name: 'extension_number', label: 'Extension number', required: ''},
        {name: 'slack_id', label: 'Slack ID', i_name: 'slack', ngModelChange: () => { this.owner.getSlackName(); } },
        {name: 'slack_name', label: 'Slack Username', placeholder: 'Your Slack Username is', i_name: 'slack'}
    ];

    private _first = true;
    private owner: ProfileViewComponent;

    constructor(owner: ProfileViewComponent) {
        this.owner = owner;
    }

    private _first_do() {
        if (this._first) {
            this._first = false;
            for (let v of this._formFields) {
                if (v.placeholder === undefined)
                    v.placeholder = v.label;
                if (v.maxlength === undefined)
                    v.maxlength = 250;
                if (v.i_name === undefined)
                    v.i_name = v.name;
            }
        }
    }

    get fields() {
        this._first_do();

        return this._formFields;
    }

    getNameByIName(i_name) {
        this._first_do();
        let res = [];
        for (let o of this._formFields) {
            if (o.i_name == i_name) res.push(o.name);
        }
        return res;
    }
}

@Component({
    selector: 'profile',
    templateUrl: 'profile-view.template.html',
    styleUrls: ['profile.component.css']
})
export class ProfileViewComponent {
    public userOne = new UsersModel();
    public $userProfileForm;
    public smtp_server = '';
    public smtp_user = '';
    public smtp_pass = '';
    public smtp_port = 0;
    public smtp_method = '';
    public extension_number = '';
    public name : string;
    public email : string;
    public password = "";
    public slack_id = "";
    public slack_name = "";

    private _inputsForShow = [];

    public formFields: FormFields;

    private _submiting = false;

    private _set_data = (res) => {
        this.userOne = res.data;
        this.smtp_server = this.userOne.smtp_server;
        this.smtp_user = this.userOne.smtp_user;
        this.smtp_pass = this.userOne.smtp_pass;
        this.smtp_port = this.userOne.smtp_port;
        this.smtp_method = this.userOne.smtp_method;
        this.extension_number = this.userOne.extension_number;
        this.name = this.userOne.name;
        this.email = this.userOne.email;
        this.slack_id = this.userOne.slack_id;
        this.slack_name = this.userOne.slack_name;
    };

    constructor(
        private fb: FormBuilder,
        private http: Http,
        private toasterService: ToasterService,
        protected el: ElementRef,
        protected validationService: ValidationService,
        public usersService: UsersService,
        private slackApi: SlackApi
    )
    {
        this.formFields = new FormFields(this);
    }

    ngOnInit(): void {
        this.usersService.getCurrent()
            .subscribe(this._set_data);
    }

    ngAfterViewInit() {
        this.$userProfileForm = $('[name="user-profile-form"]', this.el.nativeElement);
        this.validateForm();
    }

    public getSlackName() {
        if (this.slack_id != '') {
            this.slackApi.getUsernameById(this.slack_id)
                .subscribe(res => {
                    this.slack_name = res.data.name;
                });
        }
    }

    private validateForm() {
        this.$userProfileForm
            .validate({
                rules: {
                    smtp_port: {
                        digits: true
                    }
                },
                ignore: ":disabled",
                submitHandler: (form) => {
                    if (this._submiting) return;
                    this._submiting = true;
                    let sendData = {};

                    for (let i_name of this._inputsForShow) {
                        for (let name of this.formFields.getNameByIName(i_name)) {
                            sendData[name] = this[name];
                        }
                    }

                    this.usersService
                        .editCurrent(sendData)
                        .subscribe((response) => {
                            let user = ApplicationUser.getInstance();
                            user.updateUser(response.data);
                            user.user = response.data;
                            this._set_data(response);
                            this.password = "";

                            this.toasterService.pop('success', 'Success', 'Saved');

                            this._submiting = false;
                            this.closeAllInputs();
                        },
                        (error) => {
                            this.validationService.showError(error, form);
                            this._submiting = false;
                        });
                    return false;
                }
            });
    }

    isInputShow(name: string): boolean {
        return this._inputsForShow.indexOf(name) > -0.1;
    }

    setInputShow(name: string, state: boolean, input: any = null) {
        let i = this._inputsForShow.indexOf(name);
        if (state) {
            if (i > -0.1) return;
            this._inputsForShow.push(name);
            if (input) {
                setTimeout(() => {
                    input.focus();
                }, 1);
            }
        } else {
            if (i < -0.1) return;
            this._inputsForShow.splice(i, 1);
        }
        setTimeout(() => {
                if (this.$userProfileForm !== undefined) this.validateForm();
            }, 1
        );
    }

    closeAllInputs() {
        this._inputsForShow = [];
    }

    get isClosedAllInputs() {
        return this._inputsForShow.length < 0.1;
    }

    get submiting() {
        return this._submiting;
    }

}


// WEBPACK FOOTER //
// ./src/app/views/profile/profile-view.component.ts